import {
  type PageConfiguration,
  type SalesSorting,
} from "@features/sales-v3/context";
import {
  CreativesSortingOrder,
  type SalesTableReportV3MetricsFilterInput,
  SavedSearchMethod,
  SavedSearchOperator,
} from "@north-beam/nb-client-side";

export const DEFAULT_PAGE_CONFIGURATION: PageConfiguration = {
  attributionModel: "northbeam_custom",
  accountingMode: "accrual",
  attributionWindow: "1",
  breakdowns: [],
  compareDateRange: null,
  dateRange: "last7Days",
  filters: [],
  flyoutId: null,
  flyoutTab: "details",
  granularity: "campaign",
  metricFilters: {} as SalesTableReportV3MetricsFilterInput,
  statuses: null,
  searchQuery: {
    id: undefined,
    method: SavedSearchMethod.text,
    operator: SavedSearchOperator.contains,
    query: "",
  },
  sorting: {
    id: "spend",
    customComposed: false,
    metric: {
      id: "spend",
      metric: "spend",
      details: {},
    },
    type: "base",
    order: "desc",
  } as SalesSorting,
  sortingOrder: CreativesSortingOrder.desc as CreativesSortingOrder,
  timeGranularity: "daily",
  activeTab: "breakdown",
};
